import { FikoYTKokBilesenComponent } from "@/src/service/kok-bilesen/kok-bilesen.component";
import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import * as THREE from 'three';
const { degToRad } = THREE.MathUtils;
import { FikoGrupCizim } from "../../IFikoThreeJS/FikoGrupCizim";
import { FikoTakimFrezeleme } from "../../IFikoThreeJS/FikoThreeCam/FikoTakimFrezeleme";
import { FikoIsikOrtam } from "../../IFikoThreeJS/FikoIsikOrtam";
import { FikoIsikYonsel } from "../../IFikoThreeJS/FikoIsikYonsel";
import { FikoSahne } from "../../IFikoThreeJS/FikoSahne";
import { FikoImporterWRL } from "../../IFikoThreeJS/FikoImporter.WRL";
import { FikoCizimYalin } from "../../IFikoThreeJS/FikoCizimYalin";
import { FikoVektor3D } from "../../IFikoThreeJS/FikoVektor3d";
declare var TWEEN: any;


@Component({
    selector: 'fikoyt-c-acisi-3d-ek-bilesen',
    template: `
     <div style="background-color: transparent; text-shadow: 0 0 10px rgb(0 255 255 / 95%);color: white;max-width:100%;">
        <div style="display: flex;align-items: center;justify-content: center;">
        <div style="display: flex;flex-direction: column;max-width: 500px;">
                    <div>
                        <div style="color:yellow;">
                               Açıklama :
                        </div>
                        <div> Eğer B Açısı Ve C Açısı Sıfırda İken 3D Görüntüdeki Gibi Gözükmüyorsa Alttaki Kutucuktan Gerekli Ayarlamaları Yapabilirsiniz. </div>
                    </div>

                    <span style="flex:0;">
                        <div style="display: flex;align-items:center;">
                            <span style="color:yellow;">
                               Kalibre Açısı :
                            </span>
                            <input [(ngModel)]="element.kalibrasyon" (ngModelChange)="aciDegisti();" class="fikoinput" type="number" placeholder="Seç" size="1" style="flex:1;">
                        </div>
                    </span>
                    
                    <div style="color:yellow;">
                               Açı Artım Yönü :
                    </div>
                    <div> C Açısını Çevirdiğinizde Saat Yönündemi Yoksa Tersi Yöndemi Artıyor.Bunu Aşağıdaki Kutucuktan Belirleyebilirsiniz </div>
                    <select [(ngModel)]="element.yon" (ngModelChange)="aciDegisti();" style="margin-bottom:0.5em;">
                        <option value="1">Saat Yönünün Tersi</option>
                        <option value="2">Saat Yönünde</option>
                    </select>
                    <div style="color:yellow;">
                                    C Açısı : {{ element.aci }}゜
                            </div>
                            <div> C Açısını Aşağıdaki Kaydırma Çubuğundanda Ayarlayabilirsiniz </div>
                            <div>
                                <input type="range" [min]="element.userData?.FikoParametreler?.[0].ayar?.min ? element.userData?.FikoParametreler?.[0].ayar?.min:0"
                                    [max]="element.userData?.FikoParametreler?.[0].ayar?.maks ? element.userData?.FikoParametreler?.[0].ayar?.maks:100" tabindex="0" [ngModel]="element.userData?.FikoParametreler?.[0].degeri"
                                    [step]="element.userData?.FikoParametreler?.[0].ayar?.adim ? element.userData?.FikoParametreler?.[0].ayar?.adim:1"
                                    (ngModelChange)="element.userData?.FikoParametreler?.[0].degisti ? element.userData?.FikoParametreler?.[0].degisti($event):null;element.userData && element.userData.FikoParametreler && (element.userData.FikoParametreler[0].degeri=$event);CD.detectChanges();"
                                    style="width: 100%;margin-top: 0.5rem;pointer-events: all;" />
                            </div>
                </div>
        </div>
    </div>
    `,
    styleUrl: '../.component3D.scss',
    imports: [
        CommonModule,
        FormsModule,
    ]
})
export class FikoCAcisiEkBilesen extends FikoYTKokBilesenComponent {
    @Input() element;

    constructor() {
        super();
        this.subsList.push(this.FikoYT.degisti.subscribe(() => {
            this.CD.detectChanges();
        }))
    }

    override ngAfterViewInit() {
        super.ngAfterViewInit();

    }


    ngOnInit(): void {

    }


    aciDegisti() {
        this.element.userData['FikoParametreler'][0].degisti(this.element.userData['FikoParametreler'][0].degeri);
        // PERFORMANS: Emit yerine direkt ciz() kullan
        this.element?.sahne.anaGosterim.ciz();
    }

}


export class CAcisiAlt extends FikoGrupCizim {
    override type: any = "CAcisiAlt";
    /** */
    sayac = 1;

    takim: FikoTakimFrezeleme;

    sagButonlar = [
        {
            isim: "Ortam Işığı Ekle",
            simge: "lightbulb outline",
            tiklandi: () => { }
        },
        {
            isim: "Yönsel Işık Ekle",
            simge: "lightbulb",
            tiklandi: () => { }
        }
    ]
    /** */
    hizli3DMenu = [
        {
            simgeYazi: "👁‍🗨",
            renkSinif: "yellow",
            tiklandi: () => {
                this.visible = !this.visible;
                this.sahne.anaGosterim.FikoYT.degisti.emit();
            }
        },
    ]
    hizliMenu3DEk = FikoCAcisiEkBilesen;
    hizliMenu3DEkParametreler: { element: any } = { element: this };
    /** */
    aciMesh = null;
    aci: any = 0;
    kalibrasyon: number = 0;
    yon: "1" | "2" = "1";

    // PERFORMANS: Cached değerler ve reusable objeler
    private _lastAci: number = 0;
    private _lastKalibrasyon: number = 0;
    private _lastYon: "1" | "2" = "1";
    private readonly _rotationAxis = new FikoVektor3D(0.00617, 0.70708, -0.707107);
    private readonly _pivotPoint = new FikoVektor3D(0.000309, 9.88942737, -279.88942765);
    private readonly _tempVec = new FikoVektor3D();
    private readonly _tempQuat = new THREE.Quaternion();

    public override get liste(): FikoIsikOrtam[] | FikoIsikYonsel[] {
        return this.children as any;
    }

    constructor(public override sahne?: FikoSahne, name?: string) {
        super(sahne);

        const importer = new FikoImporterWRL(this.sahne);
        importer.alUrlden("./assets/3D/WTEC-KAFA/C-ALT-ACISAL-ACI.FikoCizim").then((_rslt: { yuzeyler: THREE.BufferGeometry<THREE.NormalBufferAttributes>, cizgiler: any, vertex: any }[]) => {
            for (let i = 0; i < _rslt.length; i++) {
                const e = _rslt[i];
                // e.yuzeyler.translate(-0.137, 4.964, 0);
                this.aciMesh = new FikoCizimYalin(this.sahne, name ?? "C Açısı(Alt)", e.yuzeyler, e.cizgiler, e.vertex);
                this.aciMesh.name += "." + (i + 1)
                this.aciMesh.userData['FikoArayuz'].agactaGorunur = false;
                this.aciMesh.userData['FikoArayuz'].listeGoster = false;
                this.ekle(this.aciMesh);
            }
            // const element = this.sahne.BAcisi.userData.FikoParametreler[0];
            // element.degeri = 90
            // element.degisti(90);
            // const element1 = this.sahne.CAcisi.userData.FikoParametreler[0];
            // element1.degeri = 125;
            // element1.degisti(125);
            // this.sahne?.anaGosterim.ciz();
            this.sahne?.anaGosterim.FikoYT.degisti.emit();
            //     setTimeout(() => {
            //         this.sahne?.kaynakca.konumlar.liste[0].git(2000);
            //         setTimeout(() => {
            //             this.sahne?.ekranaSigdir(this.sahne);

            //             this.sahne?.anaGosterim.surekliCiz();


            //             let BAnim = new TWEEN.Tween(element)
            //                 .to({ degeri: 0 }, 1000)
            //                 .onUpdate(() => {
            //                     // this.anaGosterim.aktifKamera.updateProjectionMatrix()
            //                     // element.degeri = element.degeri;
            //                     element.degisti(element.degeri)
            //                     this.sahne.anaGosterim.FikoYT.degisti.emit();
            //                 }).easing(TWEEN.Easing.Quadratic.Out).onComplete(() => {
            //                     this.sahne.anaGosterim.surekliCizIptal();
            //                 }).yoyo(false).repeat(0)



            //             let CAnim = new TWEEN.Tween(element1)
            //                 .to({ degeri: 0 }, 1000)
            //                 .onUpdate(() => {
            //                     // this.anaGosterim.aktifKamera.updateProjectionMatrix()
            //                     // element1.degeri = element1.degeri;
            //                     element1.degisti(element1.degeri)
            //                     this.sahne.anaGosterim.FikoYT.degisti.emit();
            //                 }).easing(TWEEN.Easing.Quadratic.Out).onComplete(() => {
            //                     this.sahne.anaGosterim.surekliCizIptal();
            //                 }).yoyo(false).repeat(0)

            //             BAnim.start();
            //             CAnim.start();
            //         }, 2500);
            //     }, 1000);
        })

        this.name = name;
        this.userData['FikoArayuz'].agactaGorunur = true;
        this.userData['FikoArayuz'].listeGoster = true;
        this.userData['FikoArayuz'].simge = "./simgeler/kurdela.webp";
        /** */
        this.takim = new FikoTakimFrezeleme(this.sahne, 32, 16, 150, 50);
        this.takim.position.set(3.73604353, 199.9648777, -534.98989008 - this.takim.boy);

        this.ekle(this.takim);
        /** */
        /** */
        // let q = new THREE.Quaternion().setFromAxisAngle(new FikoVektor3D(0, 0, 1), degToRad(0));
        // this.applyQuaternion(q);

        this.userData.oldMatrix = this.matrix.clone();

        this.userData['FikoParametreler'] = [
            {
                turu: "Çubuk",
                ayar: {
                    min: 0,
                    maks: 360,
                    adim: 0.1
                },
                degeri: this.aci,
                degisti: (dgr?) => {
                    // İlk çağrıda dgr undefined olabilir, o zaman mevcut aci değerini kullan
                    if (dgr === undefined) {
                        dgr = this.aci;
                    }

                    // PERFORMANS KRİTİK: Sadece değişiklik varsa hesapla
                    if (dgr === this._lastAci && this.yon === this._lastYon && this.kalibrasyon === this._lastKalibrasyon) {
                        return;
                    }

                    this.aci = dgr;
                    this._lastAci = dgr;
                    this._lastYon = this.yon;
                    this._lastKalibrasyon = this.kalibrasyon;

                    // PERFORMANS KRİTİK: Matrix işlemlerini optimize et
                    this.matrix.copy(this.userData.oldMatrix);
                    this.matrix.decompose(this.position, this.quaternion, this.scale);

                    // PERFORMANS: Pivot noktasını reusable vektörle çıkar
                    this.position.sub(this._pivotPoint);

                    // PERFORMANS: Inline açı hesaplama - tek hesaplama
                    const rotationAngle = this.yon === "1"
                        ? degToRad(this.kalibrasyon + this.aci)
                        : degToRad(this.kalibrasyon + (360 - this.aci));

                    // KRİTİK FİX: Eski versiyon EXACT mantığı
                    // Eski kod: this.quaternion.clone().setFromAxisAngle(...)
                    // Clone bir dummy işlem (sonra set ile eziliyor), asıl iş setFromAxisAngle
                    this._tempQuat.setFromAxisAngle(this._rotationAxis, rotationAngle);

                    // PERFORMANS: Position ve rotation'ı birlikte uygula
                    this.position.applyQuaternion(this._tempQuat);
                    this.setRotationFromAxisAngle(this._rotationAxis, rotationAngle);

                    // PERFORMANS: Pivot noktasını reusable vektörle ekle
                    this.position.add(this._pivotPoint);

                    // PERFORMANS KRİTİK: Emit kaldırıldı - sadece animasyon sırasında RAF loop emit eder
                }
            }
        ];
    }


    override raycast(raycaster: THREE.Raycaster, intersects: THREE.Intersection[]): void {
        // PERFORMANS KRİTİK: Sadece aciMesh'i raycast et (children yerine direkt obje)
        if (!this.visible || !this.aciMesh) return;

        const kesisenler = raycaster.intersectObject(this.aciMesh, true);
        if (kesisenler.length === 0) return;

        // PERFORMANS: İlk kesişimi direkt kullan
        const firstHit = kesisenler[0];
        intersects.push({
            object: this,
            distance: firstHit.distance,
            point: firstHit.point,
            face: firstHit.face,
            faceIndex: firstHit.faceIndex,
            index: firstHit.index,
            //@ts-ignore
            instanceId: this.id,
            //@ts-ignore
            altObje: firstHit.object,
            //@ts-ignore
            grup: this,
            //@ts-ignore
            enUstte: false,
            //@ts-ignore
            secilebilir: true,
            //@ts-ignore
            hizli3DMenu: this.hizli3DMenu,
            //@ts-ignore
            hizliMenu3DEk: this.hizliMenu3DEk,
            //@ts-ignore
            hizliMenu3DEkParametreler: this.hizliMenu3DEkParametreler
        } as any);
    }
}